export default __webpack_public_path__ + "static/media/overSpeeding.1e07efd8.png";